'use client'

import dynamic from 'next/dynamic'

const DevBuildStamp = dynamic(() => import('@/components/DevBuildStamp'), { ssr: false })
const DevAuthInspector = dynamic(() => import('@/components/DevAuthInspector'), { ssr: false })

export default function DevTools() {
  return (
    <>
      <DevBuildStamp />
      <DevAuthInspector />
    </>
  )
}
